import React from "react";
import { motion } from "framer-motion";
import "./AboutBanner.css";
import personImg from "../Assets/Refunnds-policy.png";
import overlayShape from "../Assets/Triangle.png";

const OffersBanner = () => {
  return (
    <section
  className="Offerse-banner"
  style={{
    background: "linear-gradient(90deg, #06b08e, #066350)",
  }}
>
      <div className="banner-content">
  {/* Animated Heading */}
  <motion.h1
    initial={{ y: -50, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: "easeOut" }}
  >
    Our <span>Refund</span> <br />
    <span>Policy</span>
  </motion.h1>

  {/* Animated Paragraph */}
  <motion.p
    initial={{ y: 30, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
  >
    Learn about our refund process, eligibility, and timelines.
    If refund approved, the amount will be credited to the source account within 7 to 10 business days.
  </motion.p>

</div>


      {/* Images Section */}
      <div className="banner-images">
        <motion.img
          src={overlayShape}
          alt="Overlay Shape"
          className="overlay-shape"
          initial={{ rotate: -180, opacity: 0 }}
          animate={{ rotate: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        />
        <motion.img
          src={personImg}
          alt="Person"
          className="person-img"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.5, ease: "easeOut" }}
        />
      </div>
    </section>
  );
};

export default OffersBanner;
